import Menu from './Menu.vue';

export * from './types';
export default Menu;



// WEBPACK FOOTER //
// ./src/pages/profile/blocks/menu/index.ts